<template>
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-12 col-xxl-10">
                <div class="text-white p-4" :class="{'bg-secondary': itemsType == 'primary', 'bg-green': itemsType == 'secondary' }" style="border-radius:50px;">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 text-center">
                            <h4 class="fs-1-3 mb-2 text-white">{{componentTitle}}</h4>
                            <p class="fs-0-8" v-html="componentParagraph" v-if="worksListData.length"></p>
                            <p v-else>Non hai ancora caricato nessun contributo fotografico</p>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-10 col-md-12 col-xl-8" v-if="worksListData.length">
                            <div class="row justify-content-center" v-if="worksListData.length">
                                <div class="col-10 col-sm-6 col-md-3 my-3" v-for="(work, index) in worksListData" :key="index">
                                    <div>
                                        <div class="frame-container">
                                            <div class="frame-square">
                                                <img :src="work.url_media" class="img-fluid w-100">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-row justify-content-start align-items-center px-2 pb-0 pt-1 bg-white">
                                        <div class="text-start">
                                            <div class="trash-wrk-table" v-if="work.appr_media != 1">
                                                <img :src="themaUrl + '/img/area_riservata/cestino-verde.svg'" class="img-fluid c-pointer" style="max-width:22px;" width="27" height="27" alt="Rimuovi" loading="lazy" @click.prevent="deleteItemDialog(work.id, 'Elimina foto', itemsType)">
                                            </div>
                                            <div class="trash-wrk-table" v-if="work.appr_media == 1">
                                                <img :src="themaUrl + '/img/area_riservata/approvata.svg'" class="img-fluid" style="max-width:22px;" width="27" height="27" alt="Rimuovi" loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center fs-1">
                                        <div class="bg-white py-2">
                                            <div valign="middle" class="text-start px-2 lh-1" v-if="work.appr_media == 0">
                                                <span class="fs-0-8 bold text-green-2">IN APPROVAZIONE</span>
                                            </div>
                                            <div valign="middle" class="text-start px-2 lh-1" v-else-if="work.appr_media == 1">
                                                <span class="fs-0-8 bold text-green">APPROVATO!</span>
                                            </div>
                                            <div valign="middle" class="text-start px-2 lh-1" v-else-if="work.appr_media == 2">
                                                <span class="fs-0-8 bold" style="color:#FF0000">RIFIUTATO</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>            
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: ['worksListData', 'itemsType', 'componentTitle', 'componentParagraph', 'themaUrl'],

    data() {
        return {
            ajaxObj: window.ajax_object,
            itemToDeleteId: 0
        }
    },

    methods: {
        deleteItemDialog(id, text, type) {
            this.$modal.show('dialog', {
                title: text,
                text: "Sei sicuro di voler eliminare l'elemento selezionato?",
                buttons: [
                    {
                    title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                    title: 'Elimina definitivamente',
                        handler: () => {
                            this.deleteItem(id, type)
                        }
                    }
                ]
            })
        },

        deleteItem(id, type) {
            let url = this.ajaxObj.ajax_url

            let formData = new FormData();
            formData.append('action', 'nl_delete_work_item')
            formData.append('_nounce_value', this.ajaxObj._nounce_value)
            formData.append('work_id', id)
            formData.append('work_type', type)

			axios.post(url, formData)
				.then((response) => {
                    // console.log(response.data)
                    if(response.data.msg == 'ok') {
                        this.$emit('refreshList', type)
                    }

				}, (error) => {
					console.log(error);
				});

            this.$modal.hide('dialog')
        }
    }
}
</script>
